export enum OrderCancellationReason {
  ADDED_BY_MISTAKE = 'added-by-mistake',
  CANCELED_BY_SENDER = 'canceled-by-sender',
  IMPOSSIBLE_REALIZATION = 'impossible-realization',
  OTHER = 'other',
}
